import React, { Component } from "react";
import Image from "gatsby-image";
import styled, { css } from "react-emotion";

const BackOverlay = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: middle;
  justify-content: space-around;
  z-index: 100;
`;

const ImageContainer = styled.div`
  position: absolute;
  top: 10%;
  width: 80%;
  height: 80%;
  text-align: center;
  vertical-align: middle;
`;

const ZoomedImage = styled.img`
  max-height: 100%;
  max-width: 100%;
  top: 50%;
  margin: auto;
  position: relative;
  z-index: 1;
`;

const ImageDescription = styled.div`
  position: relative;
  top: -100px;
  background: black;
  color: gray;
  max-width: 91%;
  left: 22%;
  font-size: 0.8em;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding-top: 100px;
  opacity: 0.5;

  &:hover {
    opacity: 1;
    color: white;
  }
`;

class ZoomImage extends Component {
  state = { showOverlay: false };

  toggleOverlay = () =>
    this.setState(({ showOverlay }) => ({ showOverlay: !showOverlay }));

  render() {
    return (
      <React.Fragment>
        <div onClick={this.toggleOverlay} >
          <Image fluid={this.props.fluid}
            style={{height: '100%' }}
            outerWrapperClassName={css`height: 100%`}
          />
        </div>
        {this.state.showOverlay && (
          <BackOverlay onClick={this.toggleOverlay}>
            <ImageContainer>
              <ZoomedImage src={this.props.original} />
              {this.props.content ? (
                <ImageDescription>
                  <div
                    dangerouslySetInnerHTML={{ __html: this.props.content }}
                  />
                </ImageDescription>
              ) : <div/>}
            </ImageContainer>
          </BackOverlay>
        )}
      </React.Fragment>
    );
  }
}

export default ZoomImage;
